import React, { useEffect, useState } from 'react';
import { Header, Footer, SideBar } from 'src/components';

import classNames from 'classnames';
import styles from './styles.module.scss';
import { Flex, Modal, Button, Text, ScrollArea, Group, UnstyledButton, Divider, Box, Checkbox, Loader } from '@mantine/core';
import { acceptEula, checkAcceptedEula, setIsAuthorizeAction } from 'src/store/user';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { shallowEqual } from 'react-redux';
import { fstat } from 'fs';
import { Auth } from 'aws-amplify';
import { removetOnboardingStatus } from 'src/helpers/localStorageHelper';
import { useAlert } from '@common/hooks';
import { PATHS } from 'src/constants';
import { useTranslation } from 'react-i18next';

interface LayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<LayoutProps> = ({ children }) => (
  <div className={classNames(styles['main-wrapper'])} id={'main-wrapper'}>
    <Header />
    <Flex style={{flex:'1'}}>
      <EulaModal/>
      <SideBar/>
      {children}
    </Flex>
    <Footer />
  </div>
);



const EulaModal = () => {
  // const [opened, setOpened] = useState(true); // Control modal visibility
  
  const [opened, setOpened] = useState( false );
  const [checked, setChecked] = useState(false); // State for the checkbox
  const dispatch = useAppDispatch();
  const { tenantId  } = useAppSelector((state) => state.user.data, shallowEqual);
  const {acceptEulaLoding,acceptEulaSuccess , checkAcceptEulaSuccess} = useAppSelector((state) => state.user, shallowEqual);
  // const {selectedSiteData} = useAppSelector((state) => state.site, shallowEqual);
  const { showAlert } = useAlert();




  useEffect(() => {
    // console.log(localStorage.getItem('eulaAccepted'));
    
      if(localStorage.getItem('eulaAccepted') == "true"){
        setOpened(false);
        return;
      }
      
      dispatch(checkAcceptedEula({ tenantId: tenantId }));
      
  }, []);

  useEffect(() => {
    
    if(checkAcceptEulaSuccess){
        localStorage.setItem('eulaAccepted','true');
        setOpened(false);
        return;
    }
    localStorage.setItem('eulaAccepted','false');
      setOpened(true);
  }, [checkAcceptEulaSuccess]);


  const handleAccept = () => {
   
    if (checked) {
      dispatch(acceptEula({ tenantId: tenantId }));
  
    } else {
      alert("Please agree to the terms and conditions before proceeding.");
    }
  };
  
  useEffect(() => {
      if(!acceptEulaSuccess){
        return;
      }
      // console.log("EULA Accepted");
      localStorage.setItem('eulaAccepted', 'true');
      setOpened(false); // Close the modal

      
  }, [acceptEulaSuccess])

  // clear Local Storage if state is empty.
  // useEffect( () => {
  //   if ( !selectedSiteData ) {
  //     localStorage.removeItem('selectedSite');
  //   }
  // } , [selectedSiteData])
  const basename = '/insight';

  const [c] = useTranslation('common');

  const onLogoutHandler = async (): Promise<void> => {
    try {
      localStorage.setItem('eulaAccepted','');
      await Auth.signOut();
      dispatch(setIsAuthorizeAction(false));
      removetOnboardingStatus();
      // localStorage.removeItem('currentUserOrganizationInfo');
      window.location.href = `${basename}${PATHS.LOGIN}`;
    } catch (error) {
      if (error instanceof Error) {
        showAlert({
          id: error.message,
          title: c('Error'),
          message: error.message,
          variant: 'error',
        });
      }
    }
  };
  
  return (
      <Modal
        opened={opened}
        onClose={() => onLogoutHandler()}
        withCloseButton={false} 
        title="End-User License Agreement"
        size="lg"
        zIndex={999999} 
        // overlayOpacity={0.6} 
        // overlayBlur={5}
      >
        <ScrollArea style={{ height: 400, position: 'relative' }}>
          {acceptEulaLoding && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1, // Ensure loader is on top
              }}
            >
              <Loader size="xl" color="blue" variant="bars" /> {/* Mantine Loader */}
            </div>
          )}

      <Text size="sm" style={acceptEulaLoding ? {opacity:'0.2'} :undefined }>
              {/* Insert the EULA content here */}
                <h2 style={{ color: '#2A2B4B' }}>Introduction</h2>
                  <p>Please read this <em>End User License Agreement</em> (hereby the “EULA”) carefully, as it sets out the terms and conditions upon which we license our software.</p>
                  <p><b>Vially Insight</b> (“the Software”) and accompanying documentation is protected by copyright laws and treaties, as well as laws and treaties related to other forms of intellectual property. Please see <a href="https://vially.io/terms-of-service" style={{ textDecoration: 'none' }}>Vially Terms and Conditions 2024</a>.</p>
                  <p><em>Vially</em>, its parent company or its subsidiaries, affiliates and suppliers (hereby “Vially”) own all intellectual property rights in the Vially Software, code, plugin, website, Insight and servers.</p>
                  <p>Your use of the Vially Software is subject to these rights and to all the terms and conditions of this EULA.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Acceptance</h2>
                  <p>By using the Software, you agree to be bound by the terms and conditions of this EULA. If you do not agree to this EULA, please discontinue now and delete all Vially code or software from your websites, computer systems and servers.</p>
                  <p>Before using, copying or downloading the Software or any code from the Vially website, you will be asked to give your express EULA to the terms and conditions set forth in this EULA.</p>
                  <p>If you do not agree to this EULA, you must not download, nor use the software or its code for any purpose whatsoever.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Software Updates</h2>
                  <p>Vially reserves the right, at its sole discretion, to change or modify its Software, website, Insight, platform or any code and deploy any changes publicly on your website without prior notice to you.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Technical Support</h2>
                  <p>Vially has no obligation to provide any upgrades, technical information or technical support of any kind.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Restriction to Transfer</h2>
                  <p>You may not assign your rights or obligations under this EULA, or redistribute, encumber, sell, rent, lease, sublicense, or otherwise transfer those rights.</p>
                  <p>Restriction on Use</p>
                  <p>You may not decompile, “reverse-engineer”, disassemble, or otherwise attempt to derive the source code of the Vially Software.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Restriction on Alteration</h2>
                  <p>You may not modify the Vially Software or create any derivative work of Vially, its website, Insight Platform, plugins, code or any accompanying documentation. You may not alter any files or libraries in any portion of the Vially Software. You may not reproduce the Vially database or create any copies of Vially data.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Restriction on Copying</h2>
                  <p>You may not copy or reproduce any part of the Vially Software.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Ownership</h2>
                  <p>Vially retains all interests, intellectual property, ownership rights and title in the Software and all copies thereof including but not limited to computer code, documents and documentation, copyrights, patents, trademarks, trade secrets, trade names, titles, designs, and methods of operation. The Software is protected by the copyright laws of the Ireland, the European Union, international treaties, conventions and other laws around the world.</p>

                  <h2 style={{ color: '#2A2B4B' }}>No Warranty</h2>
                  <p><em>Vially does not guarantee WCAG compliance!</em></p>
                  <p>Vially provides information on WCAG issues. Website, code and content changes remain the responsibility of you, your vendors or agents. If you or your users experience any unexpected technical issues, bugs or malfunctions, it is your responsibility to report such issues to <a href="mailto:support@vially.io" style={{ textDecoration: 'none' }}>support@vially.io</a> including relevant screenshots, browser versions, OS version and device type.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Limitation of Liability</h2>
                  <p>Vially does not guarantee WCAG compliance. It is your sole responsibility to ensure your website is accessible and tested for compliance with WCAG 2.1 & 2.2 or other accessibility regulations as required by law.</p>
                  <p>In no event shall Vially be liable to you or to any third party claiming through you or on your behalf.</p>
                  <p>As such, neither Vially, its directors, officers, employees or agents, nor any Vially partner, affiliate or solution provider shall in any way be liable to you or your users and you hereby waive any direct or indirect, economic, financial, special, commercial, incidental, exemplary or consequential damages, including without limitation lost profits, citations, loss of business revenue or earnings, lost data, damages caused by bugs, glitches, malfunctions or a failure to realise intended functionality, design or content, arising from or in connection with the use or performance of the Software, even if Vially or a Vially affiliate are aware of the possibility of such damages.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Disclaimer</h2>
                  <p>This software is licensed to you “as is” and Vially disclaims any and all warranties, express or implied, including without limitation any implied warranties of merchantability or fitness for a particular purpose, to the extent authorized by law. Without limiting the foregoing, Vially makes no representations that use of the software will not infringe any copyright, patent or trademark or other rights held by a third party.</p>
                  <p>Further and without limiting the foregoing, Vially makes no warranties or representations that the software will meet your requirements or that operation of the software will be uninterrupted, error free or will not harm your computer or mobile device. You assume responsibility for determining whether the software and its results, if any, are appropriate for yourself, your software, your website, your server, your product and your computer or mobile device. You shall bear the entire risk as to the performance, operation and quality of the software.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Agreement Updates</h2>
                  <p>Vially reserves the right, at its sole discretion, to change or modify or to add or remove portions of the EULA, Terms of Use or <a href="https://vially.io/privacy-policy" style={{ textDecoration: 'none' }}>Privacy Policy</a> at any time ("Updates"). You will be deemed to have accepted any update by continuing to use the Vially Software or Services.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Severability</h2>
                  <p>To the extent any section, clause, provision or sentence or part thereof of this EULA is determined to be illegal, invalid or unenforceable by competent authority in any jurisdiction, then that portion shall be severed and the remainder of this EULA shall be given full force and effect.</p>

                  <h2 style={{ color: '#2A2B4B' }}>No Waiver</h2>
                  <p>Vially's failure to assert or enforce any right contained in this EULA shall not constitute a waiver of that right.</p>

                  <h2 style={{ color: '#2A2B4B' }}>Entire Agreement</h2>
                  <p>This EULA constitutes the entire agreement between you and Vially with respect to the subject matter hereof and supersedes any prior oral or written agreements, communications, representations or undertakings provided, however, that this EULA shall coexist with and shall not be superseded by the Terms of Use, Privacy Policy and Cookie Policy. To the extent the EULA conflicts with the provisions of the Terms of Use, the conflicting provisions in the Terms of Use shall govern. To the extent the EULA conflicts with the provisions of the Privacy Policy, the conflicting provisions in the Privacy Policy shall govern.</p>
            </Text>
        </ScrollArea>

        <Box sx={{ marginTop: 20 }}>
          <Checkbox
            label="I have read the conditions and accept them."
            checked={checked}
            onChange={(event) => setChecked(event.currentTarget.checked)}
          />
        </Box>

        <Group position="right" style={{ marginTop: 20 }}>
          <Button variant="outline" onClick={() => onLogoutHandler()}>
            Log out
          </Button>
          <Button
            color="blue"
            onClick={handleAccept}
            disabled={!checked} // Disable button if not checked
            aria-label='Accept the EULA'
          >
            Accept
          </Button>
        </Group>
      </Modal>
  );
};


export default MainLayout;
